<h3 mat-dialog-title style="font-weight: bolder;">Feedback</h3>
<mat-dialog-content class="mat-dialog-content">
  <div style="margin-bottom: 10px;">
    <ng-select
       class="fdselection"
       style="z-index: 9999;"
      [items]="['Report Bug','Enhancement Suggestion','General Feedback']"
      [clearable]="false"
      [searchable]="false"
      [(ngModel)]="this.data.category"
      (change)="changeTheDialogSize()"
    ></ng-select>
  </div>
  <div *ngIf="this.data.category == 'Report Bug'">
    <div style="display: flex;align-items: center;">
       <label class="labelStyle">Summary of Bug:</label><input class="bugStyle" type="text" [(ngModel)]="bugInfo.Summary" />
    </div>
    <div style="display: flex;align-items: center;">
       <label class="labelStyle">Your Environment:</label><input class="bugStyle" type="text" [(ngModel)]="bugInfo.Env" placeholder="Describe your device (PC. iPad etc), are you using VPN? etc." />
    </div>
    <div style="display: flex;align-items: center;">
       <label class="labelStyle">Impact/Priority:</label><ng-select
       style="width: 100%;margin-left: 5px;z-index: 9998;"
       class="fdselection"
      [items]="['Low','Medium','High']"
      [clearable]="false"
      [searchable]="false"
      [(ngModel)]="bugInfo.Priority"
    ></ng-select>
    </div>
    <div style="display: flex;align-items: center;">
       <label class="labelStyle">Steps to Reproduce:</label><input style="visibility: hidden" class="bugStyle" type="text" />
    </div>
  </div>
    <div style="width: 100%">
      <div id="editorTest" style="height:150px;max-height:75%;"></div>
    </div>
    <div style="margin-top: 50px;">
      <div style="margin-bottom: 10px;">
        <div *ngIf="this.data.category == 'Report Bug'">
    <div style="display: flex;align-items: center;">
       <label class="labelStyle">Expected Result:</label><input class="bugStyle" type="text" [(ngModel)]="bugInfo.ExpResult" />
    </div>
    <div style="display: flex;align-items: center;">
       <label class="labelStyle">Actual Result:</label><input class="bugStyle" type="text" [(ngModel)]="bugInfo.ActResult" />
    </div>
    </div>
          <div>
            <span style="font-weight: bolder;">Attach Supporting Content</span>
          </div>
          <button mat-icon-button matTooltip="Choose file to upload" (click)="uploadFile()">
              <mat-icon>attachment</mat-icon>
          </button>
          <span>{{ this.displayName.length ? this.displayName.join(',') : '' }}</span>
          <input id="uploadImageForFB" multiple="multiple" type="file" name="filename" (change)="changeName()" style="display: none;"/>
      </div>
      <div class="overallBG">
          <span style="width: 100%;">Your overall satisfaction with Estate Maps</span>
      </div>
      <div style="display: flex;align-items: center;" class="feedbackClass">
        <mat-icon style="margin-right: 10px;">sentiment_very_dissatisfied</mat-icon>
        <mat-slider
          style="width: 90%;"
          [thumbLabel]="false"
          tickInterval="100"
          [color]="'amberSliderColor' + getScore()"
          step="1"
          min="-50"
          max="50"
          tickInterval="10"
          aria-label="units"
          [(value)]="this.data.score"
          [displayWith]="formatValue"
          (change)="changeTheScore()"
          ></mat-slider>
          <mat-icon style="margin-left: 10px;">sentiment_very_satisfied</mat-icon>
      </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end" >  
    <button mat-raised-button color="primary" class="aip-button" (click)="save()">Submit</button>
    <button mat-raised-button class="aip-button-alt" (click)="close()">Cancel</button>
</mat-dialog-actions>


